import { Box, Circle, HStack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { VideoMeetIcon } from '@/imports/ui/chakra/feather/video-meet';
import { useMeetingsLiveIndicators } from '@/modules/meetings/common/hooks/useMeetingsLiveIndicators';

/** Same icon + LIVE / green-dot logic as community sidebar Meetings. */
export const MeetingsHeaderLabel: React.FC<{ label: string }> = ({ label }) => {
  const { showMeetingsDot, showLiveLabel } = useMeetingsLiveIndicators({
    audienceOnly: true,
  });

  return (
    <HStack as="span" spacing="2" align="center">
      <Box as="span" position="relative" display="inline-flex" lineHeight="1">
        <VideoMeetIcon boxSize="4" />
        {showMeetingsDot && !showLiveLabel ? (
          <Circle
            position="absolute"
            top="-1"
            right="-1"
            size="2"
            bg="green.400"
          />
        ) : null}
      </Box>
      <Box as="span">{label}</Box>
      {showLiveLabel ? (
        <Text
          as="span"
          fontSize="xs"
          fontWeight="bold"
          color="green.500"
          letterSpacing="wide"
          textTransform="uppercase"
        >
          LIVE
        </Text>
      ) : null}
    </HStack>
  );
};
